module.exports = __webpack_public_path__ + "static/media/union-square-project.0f85bfb8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/union-square/union-square-project.jpg
// module id = 2114
// module chunks = 14